import CountRecord from './src/count-record'
import CountPosition from './src/count-position'
import CountOperationSelf from './src/count-operation-self'
import CountOperation from './src/count-operation'
import CountAnaesthesia from './src/count-anaesthesia'
import CountFollowup from './src/count-followup'
import CountManage from './src/count-manage'; // 经营情况表
import CountRevenue from './src/count-revenue'; // 营收情况表
import CountRevenueTrend from './src/count-revenue-trend'; // 经营情况趋势
import CountPostitionTrend from './src/count-postition-trend'; // 地域趋势
import CountOperationTrend from './src/count-operation-trend'; // 手术趋势
import CountRecordOutpatientTrend from './src/count-record-outpatient-trend'; // 门诊趋势
import CountRecordInpatientTrend from './src/count-record-inpatient-trend'; // 住院趋势
import CountWorkload from './src/count-workload' // 个人工作量

const components = [
  CountRecord,
  CountRecordOutpatientTrend,
  CountRecordInpatientTrend,
  CountPosition,
  CountOperationSelf,
  CountOperation,
  CountAnaesthesia,
  CountOperationTrend,
  CountFollowup,
  CountPostitionTrend,
  CountManage,
  CountRevenue,
  CountRevenueTrend,
  CountWorkload
];

const install = function (Vue) {
  components.map(component => {
    Vue.component(component.name, component)
  })
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '1.0.1',
  name: 'EberCount',
  install,
  CountRecord,
  CountRecordOutpatientTrend,
  CountRecordInpatientTrend,
  CountPosition,
  CountOperationSelf,
  CountOperation,
  CountAnaesthesia,
  CountOperationTrend,
  CountFollowup,
  CountPostitionTrend,
  CountManage,
  CountRevenue,
  CountRevenueTrend,
  CountWorkload
}
